import Vue from 'vue'
import config from '@/config/index'

export default {
  namespaced: true,
  state: {
    academicYear: null,
    academicYearItems: [],
    loadingStatus: false
  },
  getters: {
    academicYear (state) {
      return state.academicYear
    },
    academicYearItems (state) {
      return state.academicYearItems
    },
    loadingStatus (state) {
      return state.loadingStatus
    }
  },
  mutations: {
    setAcademicYear (state, payload) {
      state.academicYear = payload
    },
    setAcademicYearItems (state, payload) {
      state.academicYearItems = payload
    },
    SET_ACADEMIC_YEAR (state, payload) {
      state.academicYear = payload
    },
    SET_ACADEMIC_YEAR_ITEMS (state, payload) {
      state.academicYearItems = payload
    },
    SET_LOADING_STATUS (state, payload) {
      // console.log('SET_LOADING_STATUS', payload)
      state.loadingStatus = payload
    }
  },
  actions: {
    createAcademicYear ({ commit, dispatch }, payload) {
      console.log('actions createAcademicYear', payload)
      return new Promise((resolve, reject) => {
        Vue.axios.post(`${config.serverURI}/academicYears`, payload).then((response) => {
          console.log('on create academicYears', response)
          dispatch('fetchAcademicYears')
          dispatch('snackbarOnSaveSuccess')
          resolve(response)
        }).catch((error) => {
          console.log('createAcademicYear', error.response)
          reject(error)
          dispatch('snackbarOnLoadFail', error.response.data.message)
        })
      })
    },
    fetchAcademicYears (context) {
      console.log('actions fetchAcademicYears')
      context.commit('SET_LOADING_STATUS', true)
      Vue.axios.get(`${config.serverURI}/academicYears`).then((response) => {
        console.log('academicYear', response.data)
        context.commit('SET_LOADING_STATUS', false)
        context.commit('SET_ACADEMIC_YEAR_ITEMS', response.data)
      }).catch((error) => {
        console.log(error)
        context.commit('SET_LOADING_STATUS', false)
        context.dispatch('snackbarOnLoadFail', error.response.data.message)
      })
    },
    setAcademicYear (context, payload) {
      console.log('actions setAcademicYear', payload)
      if(payload) context.commit('SET_ACADEMIC_YEAR', payload)
    },
    /*fetchAcademicYears ({ commit, dispatch }) {
      console.log('actions fetchAcademicYears')
      Vue.axios.get(`${config.serverURI}/academicYears`).then((response) => {
        console.log('academicYear', response.data)
        commit('setAcademicYearItems', response.data)
      }).catch((error) => {
        console.log(error)
        dispatch('snackbarOnLoadFail', error.response.data.message)
      })
    },
    setAcademicYear ({ commit, dispatch }, payload) {
      console.log('actions setAcademicYear', payload)
      if(payload) commit('setAcademicYear', payload)
    },*/

  
    loadItems ({ commit, dispatch }, payload) {
      console.log('-> loadItems')
      return Vue.axios.get(`${config.serverURI}/academicYears`)
    },
    loadItemsAsPage ({ commit, dispatch }, pagination) {
      console.log('-> loadItemsAsPage', pagination)
      return Vue.axios.get(`${config.serverURI}/academicYears/page`, { params: pagination })
    },
    fetchItem ({ commit, dispatch }, payload) {
      console.log('-> fetchItem', payload)
      return Vue.axios.get(`${config.serverURI}/academicYears/${payload}`)
    },
    create ({ commit, dispatch }, payload) {
      console.log('-> create', payload)
      return Vue.axios.post(`${config.serverURI}/academicYears`, payload)
    },
    update ({ commit, dispatch }, payload) {
      console.log('-> update', payload)
      return Vue.axios.put(`${config.serverURI}/academicYears/${payload.id}`, payload)
    },
    delete ({ commit, dispatch }, payload) {
      console.log('-> delete', payload)
      return Vue.axios.delete(`${config.serverURI}/academicYears/${payload.id}`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/academicYear.js